import React from "react";
import Link from "next/link";

export function ActionLink({
  href,
  label,
  icon: Icon,
  onClick,
  className = "",
}) {
  return (
    <Link
      href={href}
      onClick={onClick}
      className={[
        "inline-flex items-center gap-1 text-xs font-medium text-blue-500 hover:text-blue-700 transition-colors",
        className,
      ].join(" ")}
    >
      {Icon ? <Icon className="h-4 w-4" aria-hidden="true" /> : null}
      <span>{label}</span>
    </Link>
  );
}